import { InjectionToken } from '@angular/core';

export const TABLE_WRAPPER_DESIGN_VERSION_TOKEN = new InjectionToken<string>(
  'Token for providing design version for table wrapper',
);

export interface UiUxModuleConfig {
  designVersion?: 'v1' | 'v2';
}

export const UI_UX_DARK_MODE_ENABLED = new InjectionToken<boolean>('UI_UX_DARK_MODE_ENABLED');

export const UX_SIDENAV_OPENED = new InjectionToken<boolean>('UX_SIDENAV_OPENED');

export const UI_UX_INPUT_NUMBER_PROVIDER = new InjectionToken<any>('UI_UX_INPUT_NUMBER_PROVIDER');
